<template>
    <PendingPayments></PendingPayments>
</template>
<script>
    import PendingPayments from '@/components/PendingPayments.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            PendingPayments
        }
    }
</script>